import { spacer16, spacer32 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

// Changing the viewport affects how we render images in ArticleImage.
// Any changes to widths or paddings should be reflected for images.
export const PageContainerWidth = '628px';

const PageContainer = styled.div`
  max-width: ${PageContainerWidth};
  margin: 0 auto;
  padding: ${spacer32} ${spacer16};
`;

export default PageContainer;
